import(/* webpackMode: "eager" */ "/my-ai-project/components/site-header.tsx")